// Constants for generic values that are frequently used in logic
export const YES = 'Yes';
export const NO = 'No';
export const OTHER = 'Other';
export const DNK = 'IDontKnow';
